const STORAGE_KEY = 'veraWishlist:v1';

const readHandles = () => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.filter((item) => typeof item === 'string').slice(0, 50) : [];
  } catch {
    return [];
  }
};

const writeHandles = (handles) => localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);

class VeraWishlist {
  constructor() {
    this.dialog = document.querySelector('#vera-wishlist-dialog');
    this.list = this.dialog?.querySelector('[data-wishlist-list]');
    this.empty = this.dialog?.querySelector('[data-wishlist-empty]');
    this.currency = window.Shopify?.currency?.active || 'EGP';
    this.locale = document.documentElement.lang || 'en';
    this.sync();
    document.addEventListener('click', (event) => this.onClick(event));
  }

  sync() {
    const handles = readHandles();
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const selected = handles.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? button.dataset.removeLabel : button.dataset.addLabel);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = String(handles.length);
      count.hidden = handles.length === 0;
    });
  }

  async onClick(event) {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const handle = toggle.dataset.productHandle;
      const handles = readHandles();
      const next = handles.includes(handle) ? handles.filter((item) => item !== handle) : [handle, ...handles];
      writeHandles(next);
      this.sync();
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      await this.render();
      this.dialog?.showModal();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) this.dialog?.close();

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      writeHandles(readHandles().filter((handle) => handle !== remove.dataset.wishlistRemove));
      this.sync();
      await this.render();
    }

    if (event.target === this.dialog) this.dialog.close();
  }

  formatMoney(cents) {
    try {
      return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(cents / 100);
    } catch {
      return `${(cents / 100).toFixed(2)} ${this.currency}`;
    }
  }

  async render() {
    const handles = readHandles();
    this.empty.hidden = handles.length > 0;
    this.list.hidden = handles.length === 0;
    if (!handles.length) {
      this.list.replaceChildren();
      return;
    }

    const root = window.Shopify?.routes?.root || '/';
    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        return response.ok ? response.json() : null;
      } catch {
        return null;
      }
    }));

    this.list.innerHTML = products.filter(Boolean).map((product) => `
      <article class="vera-wishlist-item">
        <button type="button" class="vera-wishlist-item__remove" data-wishlist-remove="${escapeHtml(product.handle)}" aria-label="${escapeHtml(document.documentElement.dir === 'rtl' ? 'إزالة' : 'Remove')}">×</button>
        <a class="vera-wishlist-item__link" href="${root}products/${encodeURIComponent(product.handle)}">
          ${product.featured_image ? `<img class="vera-wishlist-item__image" src="${escapeHtml(product.featured_image)}&width=480" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
          <span class="vera-wishlist-item__title">${escapeHtml(product.title)}</span>
          <span class="vera-wishlist-item__price">${this.formatMoney(product.price)}</span>
        </a>
      </article>
    `).join('');
  }
}

new VeraWishlist();
